import { v4 as uuid } from 'uuid';
import { CheckinScreenEvents, LocationScreenEvents, MainScreenEvents, PhoneValidationScreenEvents, QRScreenEvents } from "./Events"

export type BaseEvent = {
  eventID?: string
  organizationID?: string
  userID?: string
  timestamp: number
  source: 'demo-web' | 'demo-web-mobile'
  metadata?: Record<string, unknown>
}

export type SpecificEvents = (  
    MainScreenEvents |
    PhoneValidationScreenEvents |
    LocationScreenEvents | 
    QRScreenEvents |
    CheckinScreenEvents
)

// ----------------------------------------------------------------------------
export type AppEvent = BaseEvent & (
    SpecificEvents
)

/**
 * Factory to build AppEvent with base properties pre-filled
 */
export function createEvent<T extends SpecificEvents>(
    base: Omit<BaseEvent, 'eventID' | 'timestamp' | 'organizationID'> & { eventID?: string; timestamp?: number, organizationID?: string },
    specific: T
): AppEvent {
    return {
        eventID: base.eventID ?? uuid(),
        timestamp: base.timestamp ?? Date.now(),
        organizationID: base.organizationID ?? '',
        ...base,
        ...specific
    }
}
